import { inject } from '@angular/core';
import { CanMatchFn, Route, Router } from '@angular/router';
import { Pages } from '@shared/constants';

import { DataService } from '../services/data.service';

export const pageGuard: CanMatchFn = (route: Route) => {
  const router: Router = inject(Router);
  const dataService: DataService = inject(DataService);

  const routeName: string | undefined = route.path;
  const availablePages: string[] = dataService.config().pages.availablePages;

  if (routeName && !availablePages.includes(routeName)) {
    return router.parseUrl(Pages.SORRY);
  }
  return true;
};
